import { Subject } from 'rxjs';

export enum RobotType {
    PIB = 'PIB',
    ANT = 'ANT',
    NANOSAUR = 'NANOSAUR',
    FRANKA_PANDA = 'FRANKA_EMIKA_PANDA',
}

export enum DatabaseType {
    CUSTOM = 'CUSTOM',
    COCO = 'COCO',
    EMPTY = 'EMPTY',
    DICE = 'DICE',
}

export enum WizardType {
    CARD = 'card',
    COLLABORATION = 'collaboration',
    FORM = 'form',
}

export const WIZARD_CARD_SLIDE_ID = 1;
export const WIZARD_COLLABORATION_SLIDE_ID = 2;
export const WIZARD_FORM_SLIDE_ID = 3;

export interface WizardSlide {
    id: number;
    root: boolean;
    type: WizardType;
    slideTitle?: string;
    slideContent: Subject<Array<WizardSlideContentElement>>;
}

/** Helper Model for Creation, where the seletion Value (cardValue)
 * and further UI representation attributes can be defined.
 */
export interface WizardSlideContentElement {
    image: string;
    cardTitle: string;
    cardDisc: string;
    redirectSlideId: number;
    cardValue?: any;
}
